<template>
  <div :class="{ loading: loading }">
    <draggable class="image-list" v-model="internalImages" handle=".can-drag" @sort="onSort">
      <ArtImage
        class="can-drag"
        v-for="image in internalImages"
        :image="image"
        :key="image.id"
        @delete="onDeleteImage"
      />
      <v-card class="add-image-card pa-2" :elevation="loading ? 0 : 2">
        <v-btn icon fab color="primary" @click="newImageDialog = true" :loading="loading">
          <v-icon dark size="x-large"> mdi-plus </v-icon>
        </v-btn>
      </v-card>
    </draggable>
    <ImagePick
      :visible="newImageDialog"
      @close="newImageDialog = false"
      @change="onAdd"
    ></ImagePick>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import ArtImage from '@/components/livet/ArtImage'
import ImagePick from '@/components/shared/ImagePick.vue'

export default {
  name: 'InfoImages',
  props: {
    loading: { type: Boolean },
    images: { type: Array },
  },
  data() {
    return {
      internalImages: [],
      newImageDialog: false,
      newImages: [],
    }
  },
  watch: {
    images: {
      deep: true,
      immediate: true,
      handler() {
        this.newImages = []
        this.internalImages = this.images
      },
    },
  },
  components: {
    ArtImage,
    draggable,
    ImagePick,
  },
  methods: {
    emitUpdate(imageCollection) {
      const images = imageCollection
        .map((image, i) => ({ ...image, sort: i }))
        .sort((a, b) => a.sort - b.sort)
      this.$emit('change:images', { images })
    },
    onSort() {
      this.emitUpdate(this.internalImages)
    },
    onAdd(item) {
      this.newImageDialog = false
      const payload =
        item.type === 'video'
          ? [...this.internalImages, { video_url: item.url }]
          : [...this.internalImages, { li_image_id: +item.id }]
      this.emitUpdate(payload)
    },
    onDeleteImage({ id }) {
      this.internalImages = this.internalImages.filter((image) => image.id !== id)
      this.emitUpdate(this.internalImages)
    },
  },
}
</script>

<style lang="less" scoped>
.loading {
  pointer-events: none;
}
.image-list {
  max-width: 100%;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  grid-column-gap: 15px;
  grid-row-gap: 15px;
  min-height: 0; /* NEW */
  min-width: 0;
  .image-square {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .add-image-card {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 115px;
  }
}
</style>
